<template>
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#aaa"
      d="M17.7039765,6.58022575 L10.7321242,14.6656665 C10.3481323,15.1114445 9.65348035,15.1114445 9.26948848,14.6656665 L2.29630288,6.58022575 C1.76031423,5.96013716 1.96697652,5 2.79095906,5 L17.2106536,5 C18.0319695,5 18.2399651,5.96013716 17.7039765,6.58022575 Z"
    />
  </svg>
</template>
